import React, { useRef } from "react";
import { Box, Typography, Divider, Paper, Button } from "@mui/material";
import { Print as PrintIcon } from "@mui/icons-material";
import { APP_NAME, APP_DESCRIPTION } from "../constants/app";
import ReceiptFormatter from "../services/receiptFormatter";

const ThermalReceiptPreview = ({
  transaction,
  transactionDetails,
  thermalWidth = 58, // Default 58mm thermal printer width
  showPrintButton = false, // New prop to show/hide print button
}) => {
  // console.log('transaction:', transaction);
  // console.log('transactionDetails:', transactionDetails);

  const receiptRef = useRef();

  const businessName = JSON.parse(localStorage.getItem('user'))?.entity_name || APP_NAME;
  console.log('businessName:', businessName);

  if (!transaction || !transactionDetails) {
    return null;
  }

  const handlePrint = () => {
    const printContent = receiptRef.current;
    const printWindow = window.open("", "_blank");

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Receipt - ${transaction.txn_no || "N/A"}</title>
          <style>
            @page {
              size: ${thermalWidth}mm auto;
              margin: 5mm 2mm;
            }
            body {
              font-family: 'Courier New', monospace;
              font-size: 12px;
              line-height: 1.2;
              margin: 0;
              padding: 0;
              background: white;
              color: black;
              width: ${thermalWidth}mm;
            }
            .receipt-content {
              width: 100%;
              white-space: pre-wrap;
              word-break: break-word;
            }
            @media print {
              body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
            }
          </style>
        </head>
        <body>
          <div class="receipt-content">${printContent.innerHTML}</div>
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();

    // Wait for content to load, then print
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };

  // Generate receipt content using unified formatter
  const receiptContent = ReceiptFormatter.formatForBrowserPreview(
    { transaction, transactionDetails }, 
    thermalWidth
  );

  return (
    <Box>
      <Paper
        ref={receiptRef}
        sx={{
          p: 1, // Reduced padding
          // width: '100%', // Use full width
          // maxWidth: `${thermalWidth * 6}px`, // Increased max width
          width: `${thermalWidth * 1.2}mm`,
          mx: "auto",
          fontFamily: "monospace",
          fontSize: "12px",
          lineHeight: 1.2,
          backgroundColor: "white",
          color: "black",
          border: "1px dashed #ccc",
          overflow: "hidden", // Prevent overflow
        }}
      >
        <Typography
          component="pre"
          sx={{
            fontFamily: "monospace",
            fontSize: "12px",
            lineHeight: 1.2,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word", // Better word breaking
            margin: 0,
            padding: 0,
            color: "black",
            width: "100%",
            overflow: "hidden",
          }}
        >
          {receiptContent}
        </Typography>
      </Paper>

      {showPrintButton && (
        <Box sx={{ mt: 2, textAlign: "center" }}>
          <Button
            variant="contained"
            startIcon={<PrintIcon />}
            onClick={handlePrint}
            sx={{ minWidth: 120 }}
          >
            Print Receipt
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ThermalReceiptPreview;
